import { TThunkAction } from '../../types/redux';
import { openRegistrationPopup } from './actions';

export const openRegistrationPopupAction = (): TThunkAction => {
  return dispatch => {
    if (window.waitForRegistrationPopup) {
      window.waitForRegistrationPopup();
    }

    dispatch(openRegistrationPopup());
  };
};
